import React from 'react';
import styles from './DismissiblePanel.scss';
import classnames from 'classnames';


export default function DismissiblePanel(props) {
    const {
        dismiss,
        withBorder = true,
    } = props;

    if (dismiss) return null;
    return (
        <div className={
            classnames(
                props.className, {
                    [styles.dismissibleBorder]: withBorder,
                }
            )
        }
        data-cy="DismissiblePanel"
        >
            <DismissHeader
                onGoBack={props.onGoBack}
                onDismiss={props.onDismiss}
                data-cy="DismissiblePanel-onGoBack"
            />
            <div className={styles.dismissiblePanel} data-cy="DismissiblePanel-children">
                {props.children}
            </div>
        </div>
    );
}

export const DismissHeader = (props) => (
    <div className={styles.dismissHeader} data-cy="DismissiblePanel-dismissHeader">
        <div className={styles.goBack}>
            <span
                className={
                    classnames({
                        [styles.hidden]: !props.onGoBack
                    })
                }
                onClick={props.onGoBack}
                data-cy="DismissiblePanel-onGoBack"
            >
                <span
                    className={
                        classnames(
                            props.className,
                            styles.backArrow
                        )
                    }
                />
                Go Back
            </span>
        </div>
        <DismissButton className={styles.dismissButton} onClick={props.onDismiss}/>
    </div>
);


export const DismissButton = (props) => (
    <span
        data-cy="DismissiblePanel-DismissButton"
        className={classnames(styles.dismiss, props.className)}
        onClick={props.onClick}
    />
);


export const DismissibleHeader = (props) => (
    <div className={classnames(styles.dismissibleHeader, props.className)} data-cy="DismissiblePanel-DismissibleHeader">
        <h1 data-cy="DismissiblePanel-h1">{props.title}</h1>
        <h2 data-cy="DismissiblePanel-h2">{props.subTitle}</h2>
        <h3 data-cy="DismissiblePanel-h3">{props.message}</h3>
    </div>
);
